module.exports = __webpack_public_path__ + "img/aio-card-template.adb8cad2.svg";